import { DocumentCivilUnionFormVM } from 'civil-status/view-models/document-birth-form';
import { PageMode } from 'civil-status/view-models/page-mode';
import { FormikErrors, FormikTouched } from 'formik';
import { Divider, Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import ListGender from 'shell/components/shared/gender';
import { DatePicker } from '@mui/lab';
import MatricolaList from './matricola-list';
import { memo, useMemo } from 'react';
// import ListCivilStatus from './list-civil-status';

interface DocumentUnionForm {
  values?: DocumentCivilUnionFormVM;
  errors?: FormikErrors<DocumentCivilUnionFormVM>;
  touched?: FormikTouched<DocumentCivilUnionFormVM>;
  onChange: (
    key: keyof DocumentCivilUnionFormVM,
    value: DocumentCivilUnionFormVM[keyof DocumentCivilUnionFormVM]
  ) => void;
  onChanges: (value: DocumentCivilUnionFormVM) => void;
  mode: PageMode;
}
const UnionForm = ({ values, touched, errors, mode, onChange, onChanges }: DocumentUnionForm) => {
  const disabled = useMemo(() => {
    return mode === PageMode.Detail;
  }, [mode]);

  return (
    <>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={4}>
          <DatePicker
            label="Data Unione Civile *"
            aria-label="Data Unione Civile"
            value={values?.civilUnionDate || null}
            disabled={disabled}
            onChange={(value) => onChange('civilUnionDate', value)}
            renderInput={(params) => (
              <PmiTextField
                id="civilUnionDate"
                name="civilUnionDate"
                {...params}
                fullWidth
                error={touched?.civilUnionDate && Boolean(errors?.civilUnionDate)}
                helperText={errors?.civilUnionDate}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={8}>
          <PmiTextField
            aria-label="Comune Unione Civile"
            label="Comune Unione Civile *"
            id="civilUnionMunicipality"
            name="civilUnionMunicipality"
            value={values?.civilUnionMunicipality || ''}
            helperText={errors?.civilUnionMunicipality}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('civilUnionMunicipality', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('civilUnionMunicipality', event?.target.value);
            }}
            error={touched?.civilUnionMunicipality && Boolean(errors?.civilUnionMunicipality)}
            fullWidth
            disabled={disabled}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <MatricolaList
            aria-label="Matricola"
            label="Matricola"
            id="matricola"
            disabled={disabled}
            surname={values?.surname || ''}
            name={values?.name || ''}
            value={values?.matricola || ''}
            dateBirth={values?.birthday || null}
            onChanges={(value) => onChanges(value)}
            error={touched?.matricola && Boolean(errors?.matricola)}
            isSmallSize
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Cognome"
            label="Cognome *"
            id="surname"
            name="surname"
            fullWidth
            disabled={disabled}
            value={values?.surname || ''}
            onChange={(event) => onChange('surname', event?.target.value)}
            error={touched?.surname && Boolean(errors?.surname)}
            helperText={errors?.surname}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Nome"
            label="Nome *"
            id="name"
            name="name"
            fullWidth
            disabled={disabled}
            value={values?.name || ''}
            onChange={(event) => onChange('name', event?.target.value)}
            error={touched?.name && Boolean(errors?.name)}
            helperText={errors?.name}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={3}>
          <ListGender
            value={values?.gender || ''}
            onChange={(event) => onChange('gender', event?.target.value)}
            error={touched?.gender && Boolean(errors?.gender)}
            disabled={disabled}
            isSmallSize
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={4}>
          <DatePicker
            label="Data nascita"
            aria-label="Data nascita"
            value={values?.birthday || null}
            disabled={disabled}
            onChange={(value) => onChange('birthday', value)}
            renderInput={(params) => (
              <PmiTextField
                id="birthday"
                name="birthday"
                {...params}
                fullWidth
                error={touched?.birthday && Boolean(errors?.birthday)}
                helperText={errors?.birthday}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={2}>
          <PmiTextField
            aria-label="Anni"
            label="Anni"
            id="yearsDeclarant1"
            name="yearsDeclarant1"
            fullWidth
            disabled={disabled}
            value={values?.yearsDeclarant1 || ''}
            onChange={(event) => onChange('yearsDeclarant1', event?.target.value)}
            error={touched?.yearsDeclarant1 && Boolean(errors?.yearsDeclarant1)}
            helperText={errors?.yearsDeclarant1}
            inputProps={{
              maxLength: '2',
            }}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={3}>
          <PmiTextField
            aria-label="Anno Nascita"
            label="Anno Nascita"
            id="yearDateDeclarant1"
            name="yearDateDeclarant1"
            fullWidth
            disabled={disabled}
            value={values?.yearDateDeclarant1 || ''}
            onChange={(event) => onChange('yearDateDeclarant1', event?.target.value)}
            error={touched?.yearDateDeclarant1 && Boolean(errors?.yearDateDeclarant1)}
            helperText={errors?.yearDateDeclarant1}
            inputProps={{
              maxLength: '4',
            }}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Comune nascita"
            label="Comune nascita"
            id="municipalityBirth"
            name="municipalityBirth"
            fullWidth
            disabled={disabled}
            value={values?.municipalityBirth || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('municipalityBirth', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('municipalityBirth', event?.target.value);
            }}
            error={touched?.municipalityBirth && Boolean(errors?.municipalityBirth)}
            helperText={errors?.municipalityBirth}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} md={9} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Comune residenza"
            label="Comune residenza"
            id="residenceMunicipalityDeclarant1"
            name="residenceMunicipalityDeclarant1"
            fullWidth
            disabled={disabled}
            value={values?.residenceMunicipalityDeclarant1 || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('residenceMunicipalityDeclarant1', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('residenceMunicipalityDeclarant1', event?.target.value);
            }}
            error={
              touched?.residenceMunicipalityDeclarant1 &&
              Boolean(errors?.residenceMunicipalityDeclarant1)
            }
            helperText={errors?.residenceMunicipalityDeclarant1}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
        <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
          <span>F2 per Milano</span>
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={7}>
          <PmiTextField
            label="Cittadinanza"
            aria-label="Cittadinanza"
            id="citizenship-1"
            name="citizenship-1"
            fullWidth
            value={values?.citizenshipDeclarant1 || ''}
            disabled={disabled}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('citizenshipDeclarant1', 'ITALIANA');
                return;
              }
            }}
            onChange={(event) => onChange('citizenshipDeclarant1', event.target.value)}
            error={touched?.citizenshipDeclarant1 && Boolean(errors?.citizenshipDeclarant1)}
          />
        </Grid>
        {/* <Grid item xs={12} style={{ paddingTop: '10px' }} md={5}>
          <ListCivilStatus
            id="martitalStatusDeclarant1"
            disabled={disabled}
            value={values?.martitalStatusDeclarant1 || ''}
            onChange={(event) => {
              onChange('martitalStatusDeclarant1', event?.target.value);
            }}
            error={touched?.martitalStatusDeclarant1 && Boolean(errors?.martitalStatusDeclarant1)}
          />
        </Grid> */}
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Cognome post unione"
            label="Cognome post unione"
            id="surnamePostUnionDeclarant1"
            name="surnamePostUnionDeclarant1"
            fullWidth
            disabled={disabled}
            value={values?.surnamePostUnionDeclarant1 || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('surnamePostUnionDeclarant1', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('surnamePostUnionDeclarant1', event?.target.value);
            }}
            error={
              touched?.surnamePostUnionDeclarant1 && Boolean(errors?.surnamePostUnionDeclarant1)
            }
            helperText={errors?.surnamePostUnionDeclarant1}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
      </Grid>
      {/* Cittadino 2 */}
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <span>Secondo dichiarante </span>
          <Divider />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <MatricolaList
            aria-label="Matricola"
            label="Matricola"
            id="matricola2"
            surname={values?.surname2 || ''}
            name={values?.name2 || ''}
            dateBirth={values?.birthday2 || null}
            disabled={disabled}
            value={values?.matricola2 || ''}
            onChanges={(value) =>
              onChanges({
                matricola2: value.matricola,
                birthday2: value.birthday,
                gender2: value.gender,
                name2: value.name,
                surname2: value.surname,
              })
            }
            error={touched?.matricola2 && Boolean(errors?.matricola2)}
            isSmallSize
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Cognome"
            label="Cognome *"
            id="surname2"
            name="surname2"
            fullWidth
            disabled={disabled}
            value={values?.surname2 || ''}
            onChange={(event) => onChange('surname2', event?.target.value)}
            error={touched?.surname2 && Boolean(errors?.surname2)}
            helperText={errors?.surname2}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Nome"
            label="Nome *"
            id="name2"
            name="name2"
            fullWidth
            disabled={disabled}
            value={values?.name2 || ''}
            onChange={(event) => onChange('name2', event?.target.value)}
            error={touched?.name2 && Boolean(errors?.name2)}
            helperText={errors?.name2}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={3}>
          <ListGender
            value={values?.gender2 || ''}
            onChange={(event) => onChange('gender2', event?.target.value)}
            error={touched?.gender2 && Boolean(errors?.gender2)}
            disabled={disabled}
            isSmallSize
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={4}>
          <DatePicker
            label="Data nascita"
            aria-label="Data nascita"
            value={values?.birthday2 || null}
            disabled={disabled}
            onChange={(value) => onChange('birthday2', value)}
            renderInput={(params) => (
              <PmiTextField
                id="birthday2"
                name="birthday2"
                {...params}
                fullWidth
                error={touched?.birthday2 && Boolean(errors?.birthday2)}
                helperText={errors?.birthday2}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={2}>
          <PmiTextField
            aria-label="Anni"
            label="Anni"
            id="yearsDeclarant2"
            name="yearsDeclarant2"
            fullWidth
            disabled={disabled}
            value={values?.yearsDeclarant2 || ''}
            onChange={(event) => onChange('yearsDeclarant2', event?.target.value)}
            error={touched?.yearsDeclarant2 && Boolean(errors?.yearsDeclarant2)}
            helperText={errors?.yearsDeclarant2}
            inputProps={{
              maxLength: '2',
            }}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={3}>
          <PmiTextField
            aria-label="Anno Nascita"
            label="Anno Nascita"
            id="yearDateDeclarant2"
            name="yearDateDeclarant2"
            fullWidth
            disabled={disabled}
            value={values?.yearDateDeclarant2 || ''}
            onChange={(event) => onChange('yearDateDeclarant2', event?.target.value)}
            error={touched?.yearDateDeclarant2 && Boolean(errors?.yearDateDeclarant2)}
            helperText={errors?.yearDateDeclarant2}
            inputProps={{
              maxLength: '4',
            }}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Comune nascita"
            label="Comune nascita"
            id="municipalityBirth2"
            name="municipalityBirth2"
            fullWidth
            disabled={disabled}
            value={values?.municipalityBirth2 || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('municipalityBirth2', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('municipalityBirth2', event?.target.value);
            }}
            error={touched?.municipalityBirth2 && Boolean(errors?.municipalityBirth2)}
            helperText={errors?.municipalityBirth}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} md={9} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Comune residenza"
            label="Comune residenza"
            id="residenceMunicipalityDeclarant2"
            name="residenceMunicipalityDeclarant2"
            fullWidth
            disabled={disabled}
            value={values?.residenceMunicipalityDeclarant2 || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('residenceMunicipalityDeclarant2', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('residenceMunicipalityDeclarant2', event?.target.value);
            }}
            error={
              touched?.residenceMunicipalityDeclarant2 &&
              Boolean(errors?.residenceMunicipalityDeclarant2)
            }
            helperText={errors?.residenceMunicipalityDeclarant2}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
        <Grid item xs={12} md={3} style={{ paddingTop: '10px' }}>
          <span>F2 per Milano</span>
        </Grid>
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }} md={7}>
          <PmiTextField
            label="Cittadinanza"
            aria-label="Cittadinanza"
            id="citizenship-2"
            name="citizenship-2"
            fullWidth
            value={values?.citizenshipDeclarant2 || ''}
            disabled={disabled}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('citizenshipDeclarant2', 'ITALIANA');
                return;
              }
            }}
            onChange={(event) => onChange('citizenshipDeclarant2', event.target.value)}
            error={touched?.citizenshipDeclarant2 && Boolean(errors?.citizenshipDeclarant2)}
          />
        </Grid>
        {/* <Grid item xs={12} style={{ paddingTop: '10px' }} md={5}>
          <ListCivilStatus
            id="martitalStatusDeclarant2"
            disabled={disabled}
            value={values?.martitalStatusDeclarant2 || ''}
            onChange={(event) => {
              onChange('martitalStatusDeclarant2', event?.target.value);
            }}
            error={touched?.martitalStatusDeclarant2 && Boolean(errors?.martitalStatusDeclarant2)}
          />
        </Grid> */}
      </Grid>
      <Grid item container xs={12} spacing={2}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Cognome post unione"
            label="Cognome post unione"
            id="surnamePostUnionDeclarant2"
            name="surnamePostUnionDeclarant2"
            fullWidth
            disabled={disabled}
            value={values?.surnamePostUnionDeclarant2 || ''}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('surnamePostUnionDeclarant2', 'MILANO');
                return;
              }
            }}
            onChange={(event) => {
              onChange('surnamePostUnionDeclarant2', event?.target.value);
            }}
            error={
              touched?.surnamePostUnionDeclarant2 && Boolean(errors?.surnamePostUnionDeclarant2)
            }
            helperText={errors?.surnamePostUnionDeclarant2}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

UnionForm.displayName = 'Document Civil-union form component';

const UnionFormComponent = memo(UnionForm);

export default UnionFormComponent;
